var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8C9.33 8 14 9.17 14 11.5V14H0V11.5C0 9.17 4.67 8 7 8ZM15 8C17.3301 8.00007 22 9.17007 22 11.5V14H16V11.5C16 10.0201 15.1902 8.88979 14.0303 8.0498C14.3801 8.01983 14.7101 8 15 8ZM7 0C8.66 0 9.99023 1.34 9.99023 3C9.99023 4.66 8.66 6 7 6C5.34 6 4 4.66 4 3C4 1.34 5.34 0 7 0ZM15 0C16.66 0 17.9902 1.34 17.9902 3C17.9902 4.66 16.66 6 15 6C13.34 6 12 4.66 12 3C12 1.34 13.34 0 15 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9778470a0ae704e77b4ac213ab170a58.svg";
export { ForwardRef as ReactComponent };